import privilegesMixin from '@/mixins/common/privilegesMixin'
import { mapGetters } from 'vuex'
import { STAKEHOLDER_TYPE } from '@/../shared/valueholders/stakeholder-types'

export default {
  mixins: [privilegesMixin],
  computed: {
    ...mapGetters('access', ['getCPOS', 'getAllOptionsCPO']),
    ...mapGetters('currentUser', {
      currentUserRole: 'getCurrentUserRole',
    }),
    identity() {
      return this.$auth.user['https://evmaps.nl/identity']
    },
    isAllowedToEditCpo() {
      return this.superuser || this.admin
    },
    noCpoLabel() {
      return `${this.$i18n.t('none')} CPO`
    },
    isUserCpo() {
      return this.currentUserRole === 'cpo'
    },
    cpoSelectOptions() {
      let options;

      if (this.isUserCpo && this.identity?.category === 'cpo') {
        options = this.getAllOptionsCPO
          .map(cpo => {
            if (cpo.uuid === this.identity.uuid || cpo.uuid === this.currentCpo?.uuid) {
              return { value: cpo.uuid, label: cpo.name };
            }
          })
          .filter(Boolean);
      } else {
        options = this.getAllOptionsCPO.map(cpo => ({ value: cpo.uuid, label: cpo.name }));
      }

      // Voeg de 'null'-optie toe
      const nullOption = { label: `${this.$i18n.t('none')} CPO`, value: null };

      // Sorteer alfabetisch op label
      const sortedOptions = options.sort((a, b) => {
        if (!a.label) return -1;
        if (!b.label) return 1;
        return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
      });

      // Plaats null-optie altijd bovenaan
      return [nullOption, ...sortedOptions];
    },

    currentCpo() {
      if (!this.chargingpoint) return

      if (!this.stakeholders?.length) return null

      return this.stakeholders.find(stakeholder => stakeholder.category === STAKEHOLDER_TYPE.CPO)
    },
  }
}
